export function replaceDefaultValues<
  U extends { [x: string]: any },
  T extends keyof U
>(obj: U, defaultValues?: any): { [K in T]: any } {
  let newObj = {} as U;

  for (const key in obj) {
    newObj[key] = defaultValues?.[key] ?? obj[key];
  }

  return newObj;
}
